import { render, staticRenderFns } from "./myIssueXq.vue?vue&type=template&id=1a1f38b4&scoped=true"
import script from "./myIssueXq.vue?vue&type=script&lang=js"
export * from "./myIssueXq.vue?vue&type=script&lang=js"
import style0 from "./myIssueXq.vue?vue&type=style&index=0&id=1a1f38b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1f38b4",
  null
  
)

export default component.exports